import { render, staticRenderFns } from "./IadeArizaDetayFaturaButton.vue?vue&type=template&id=29bf90fd&"
import script from "./IadeArizaDetayFaturaButton.vue?vue&type=script&lang=js&"
export * from "./IadeArizaDetayFaturaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports